import axios from "./axios";

export async function fetchOutboundCommunications(params) {
  return axios({
    method: "get",
    url: "/outbound_communications",
    params,
  }).then((response) => response.data);
}

export async function fetchOutboundCommunication(id) {
  return axios.get(`/outbound_communications/${id}`).then((response) => response.data);
}

export async function fetchOutboundCommunicationPdf(id) {
  const response = await axios.get(`/outbound_communications/${id}/pdf`, {
    responseType: "blob",
  });
  return pdfUrlFromResponse(response);
}

export async function fetchOutboundCommunicationsExportPdf(ids) {
  const response = await axios.get("/outbound_communications/export_pdf", {
    params: { ids },
    responseType: "blob",
  });
  return pdfUrlFromResponse(response);
}

async function pdfUrlFromResponse(response) {
  if (response.status >= 400) {
    return Promise.reject(await parsePdfErrorPayload(response.data, response.statusText));
  }
  const blob = new Blob([response.data], { type: "application/pdf" });
  return { pdf_url: URL.createObjectURL(blob) };
}

export async function parseOutboundCommunicationPdfError(error) {
  const response = error?.response;
  if (!response) return error;
  return parsePdfErrorPayload(response.data, response.statusText);
}

async function parsePdfErrorPayload(data, fallback) {
  if (data instanceof Blob) {
    try {
      data = JSON.parse(await data.text());
    } catch {
      data = { message: fallback };
    }
  }
  return data ?? { message: fallback };
}
